<div class="d-block position-relative">
  <a (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </a>

  <div *ngIf="status==='loading'" class="d-flex flex-column align-items-center loader">
    <mat-spinner diameter="150" mode="indeterminate"></mat-spinner>
    <span>Transfer in <br>progress</span>
  </div>

  <div *ngIf="status==='show-form'">
    <h1>Send requests</h1>

    <section class="select-request-type-section">
      <mat-radio-group [(ngModel)]="requestType" color="primary">
        <mat-radio-button class="request-type-margin" value="link">Generate Link</mat-radio-button>
        <mat-radio-button class="request-type-margin" value="email">Send Email</mat-radio-button>
      </mat-radio-group>
    </section>

    <form [formGroup]="createRequestFileForm" (submit)="submit()">
      <div class="share-medix-input-container">
        <label class="sr-only">Data Owner Email</label>
        <div class="input-group">
          <input type="email" name="email" placeholder="Data Owner Email" formControlName="email"  [ngClass]="createRequestFileForm.controls.email.invalid && (createRequestFileForm.controls.email.dirty || createRequestFileForm.controls.email.touched) ? 'share-medix-input-group error-field' : 'share-medix-input-group'">
        </div>
      </div>

      <div *ngIf="createRequestFileForm.controls.email.invalid && (createRequestFileForm.controls.email.dirty || createRequestFileForm.controls.email.touched)">
        <div class="share-medix-input-error" *ngIf="createRequestFileForm.controls.email.errors?.['email']">Provided email is incorrect!</div>
        <div class="share-medix-input-error" *ngIf="createRequestFileForm.controls.email.errors?.['required']">Field email can't be empty.</div>
      </div>

      <div class="share-medix-input-container" *ngIf="requestType==='email'">
        <label class="sr-only" for="subject">subject</label>
        <div class="input-group">
          <input type="text" id="subject" name="subject" placeholder="Subject (optional)" formControlName="email_subject" class="share-medix-input-group">
        </div>
      </div>

      <div class="share-medix-input-container" *ngIf="requestType==='email'">
        <label class="sr-only" for="message">message</label>
        <div class="input-group">
          <textarea type="text" id="message" name="message" placeholder="Message (optional)" formControlName="email_body" class="share-medix-input-group share-medix-textarea" rows="5"></textarea>
        </div>
      </div>

      <button class="share-medix-btn" type="submit" [disabled]="!createRequestFileForm.valid">
        <span *ngIf="requestType==='link'">Generate Link</span>
        <span *ngIf="requestType==='email'">Send request</span>
      </button>
    </form>
  </div>

  <div *ngIf="status==='done-created-link'" class="d-flex flex-column align-items-center done-section">
    <h2>Here is your link!</h2>
    <div class="link-input" (mousedown)="copyLink()">
      <span>{{link}}</span>
      <img src="./assets/ui/svg/grey/copy-button.svg" class="copy-img">
    </div>
    <button class="share-medix-btn" (click)="copyAndClose()">Copy link</button>
  </div>

  <div *ngIf="status==='done-send-email'" class="d-flex flex-column align-items-center done-section done-section-email">
    <h2>Done!</h2>
    <span>Your email has been sent to {{email}}.</span>
    <img class='done-img' [src]="'./assets/ui/svg/blue/icon-check-correct-animated.svg?v=' + doneTime">
    <button class="share-medix-btn" mat-dialog-close="true">OK</button>
  </div>
</div>
